import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'agendario_jwt_token';
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || 'http://localhost:5000';

export const authService = {
  /**
   * Salva o token JWT no localStorage
   */
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Obtém o token JWT do localStorage
   */
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Remove o token JWT do localStorage
   */
  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Verifica se o token é válido (não expirado)
   */
  isTokenValid() {
    const token = this.getToken();
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Token expira em menos de 5 minutos? Consideramos inválido
      if (decoded.exp < currentTime + 300) {
        return false;
      }

      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Erro ao decodificar token:', error);
      return false;
    }
  },

  /**
   * Obtém informações do usuário decodificando o token
   */
  getUserInfo() {
    const token = this.getToken();
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      return {
        userId: decoded.userId || decoded.sub,
        email: decoded.email,
        name: decoded.name,
        theme: decoded.theme ? parseInt(decoded.theme) : null,
        exp: decoded.exp
      };
    } catch (error) {
      console.error('Erro ao decodificar token:', error);
      return null;
    }
  },

  /**
   * Obtém o tema do usuário do JWT
   * @returns {number|null} Valor do enum ThemeType ou null se não definido
   */
  getThemeFromToken() {
    const userInfo = this.getUserInfo();
    return userInfo?.theme || null;
  },

  /**
   * Redireciona para a página de login
   */
  redirectToLogin() {
    this.removeToken();
    window.location.href = LOGIN_URL;
  },

  /**
   * Processa token recebido via query string após login
   */
  processLoginCallback() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    
    if (token) {
      this.setToken(token);
      // Remove token da URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return true;
    }
    
    return false;
  },

  /**
   * Verifica autenticação e redireciona se necessário
   */
  checkAuth() {
    // Primeiro verifica se há token no query string
    const hasNewToken = this.processLoginCallback();
    
    if (hasNewToken) {
      return true;
    }

    // Verifica se o token atual é válido
    if (!this.isTokenValid()) {
      this.redirectToLogin();
      return false;
    }

    return true;
  }
};
